import { Button, withStyles } from '@material-ui/core';

const PurpleButton = withStyles({
  root: {
    minWidth: '30px',
    color: 'white',
    padding: '0px 10px',
    margin: 5,
    borderRadius: 20,
    fontSize: '1.3rem',
    background: '#800080',
    '&:hover': {
      background: '#A000A0',
    },
    '&:active': {
      background: '#A000A0',
    },
  },
  disabled: {
    background: '#C4C4C4',
  },
})(Button);

export default PurpleButton;
